import { chordFor, hits, type Style } from '../style';

/** Hiplife: hip-hop drums under highlife-ish keys. */
const CHORDS = [[57, 60, 64], [53, 57, 60], [60, 64, 67], [55, 59, 62]]; // Am F C G

export const HIPLIFE: Style = {
  bpm: 96,
  swing: 0.18,
  play(kit, step, bar, t, len, energy) {
    const chord = chordFor(CHORDS, bar);
    if (hits('x......x..x.....', step)) kit.kick(t);
    if (hits('....x.......x...', step)) kit.clap(t, 0.8);
    kit.hat(t, step === 14, step % 4 === 2 ? 1 : 0.5 + energy * 0.3);
    if (hits('x......x..x.....', step)) kit.bass(t, (chord[0] ?? 57) - 24, len * 3);
    if (hits('..x.......x.....', step)) kit.keys(t, chord, len * 3, 0.9);
    if (energy > 0.6 && hits('...x...x...x...x', step)) kit.bell(t, step === 15);
  },
};
